import { useMemo } from 'react';
import { CNA_TABS } from '../../constants';
import PageTabs from '../../../../components/other/page-tabs';
import React from 'react';
import { useAuth } from '../../../../container/authContext';
import { usePermission } from '../../../../container/permissionContext';

const Header = () => {
  const { user = {} } = useAuth();
  const { isSuperAdmin, isCompanySystemAdministrator, hasPermissionByCodeName } = usePermission();

  const { is_unit_user } = user;
  let layout = null;

  const tabs = useMemo(() => {
    if (
      isSuperAdmin() ||
      isCompanySystemAdministrator() ||
      (hasPermissionByCodeName('cna_templates_management') && hasPermissionByCodeName('manage_cna_assignments'))
    ) {
      return CNA_TABS;
    }

    if (hasPermissionByCodeName('cna_templates_management')) {
      return CNA_TABS.slice(1);
    }

    if (hasPermissionByCodeName('manage_cna_assignments')) {
      return CNA_TABS.slice(0, 1);
    }

    return CNA_TABS.slice(0, 1);
  }, [user, isSuperAdmin, isCompanySystemAdministrator]);
  if (!is_unit_user) {
    layout = <PageTabs tabs={tabs} />;
  }
  return layout;
};

export default Header;
